import { render, staticRenderFns } from "./45.vue?vue&type=template&id=5569c4c9&"
import script from "./45.vue?vue&type=script&lang=js&"
export * from "./45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports